import { Component, Input, HostListener } from '@angular/core';
import { WaitLoadingService } from './wait-loading.service';

@Component({
  selector: 'waitLoading',
  templateUrl: 'waitLoading.template.html'
})
export class WaitLoadingComponent {
  @Input()
  loadingMessage;
  @Input()
  maxView = true;
  @Input()
  showCancel = false;

  show = true;

  constructor(private waitService: WaitLoadingService) { }

  public getCssClass(): string {
    return this.maxView ? 'max-view' : undefined;
  }

  isShowCancel(): boolean {
    return this.showCancel;
  }

  @HostListener('document:keydown.escape', ['$event'])
  public close() {
    if (this.showCancel) {
      this.waitService.cancelWaiting();
    }
    this.waitService.escapePressesd();
    this.show = false;
  }
}
